export { DefaultHeroLayout, DefaultHeroLayout as default } from "./Default";
